import Sidebar from "components/organisms/Sidebar";
import { useAppTheme } from "contexts";
import { Outlet } from "react-router-dom";

import { Body, Container, Content } from "./Dashboard.styles";
import { DashboardProps } from "./Dashboard.types";

const Dashboard: React.FC<DashboardProps> = ({
  menu,
  bottomMenu,
  userInfo,
  defaultLanguage,
  languages,
  onLanguageChange,
  onLogout,
}) => {
  const { sidebar, expandSidebarHover } = useAppTheme();
  return (
    <Container>
      <Sidebar
        collapsed={!sidebar.expandedHover && sidebar.collapsed}
        userInfo={userInfo}
        menu={menu}
        bottomMenu={bottomMenu}
        defaultLanguage={defaultLanguage}
        languages={languages}
        onLanguageChange={onLanguageChange}
        onHover={() => expandSidebarHover?.(true)}
        onBlur={() => expandSidebarHover?.(false)}
        onLogout={onLogout}
      />
      <Body collapsed={!sidebar.expandedHover && sidebar.collapsed}>
        <Content>
          <Outlet />
        </Content>
      </Body>
    </Container>
  );
};

export default Dashboard;
